import axios from 'axios';
import EnvService from '@/services/env.service'

axios.defaults.baseURL = EnvService.apiBaseURL




// Set the AUTH token for any request
axios.interceptors.request.use(function (config) {
  config.auth = {
    username: 'test',
    password: ''
  };
  return config;
}, function (error) {
  return Promise.reject(error)
})


const ApiService = {
  getCurtainsPrice(data) {
    return new Promise((resolve, reject) => {
      axios.post('/gordijn', data).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error)
      })
    })
  },

  getRollCurtainsPrice(data) {
    return new Promise((resolve, reject) => {
      axios.post('/rolgordijn', data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDuettePlissePrice(data) {
    return new Promise((resolve, reject) => {
      axios.post('/duetteplisse', data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getHorizontalBlindsPrice(data) {
    return new Promise((resolve, reject) => {
      axios.post('/jaloezie', data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDuorolPrice(data) {
    return new Promise((resolve, reject) => {
      axios.post('/duorol', data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendEmail(data) {
    return new Promise((resolve, reject) => {
      axios.post('/richtprijs', data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error) 
      })
    })
  }
}

export default ApiService